/**
 * Copies text to the clipboard using the Clipboard API.
 *
 * @param text - The text to copy to clipboard
 * @returns Promise that resolves to true if successful, false otherwise
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

/**
 * Constructs a share URL that deep-links to a paper in the student portal.
 *
 * @param portalKey - The student's portal key
 * @param documentId - The document ID to deep-link to
 * @returns The full portal URL that deep-links to the paper
 */
export function getShareUrl(portalKey: string, documentId: string): string {
  return `${window.location.origin}/portal/${portalKey}/paper/${documentId}`;
}
